import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen, Loader2, Lock } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "forgot") {
        await api.post("/auth/forgot-password", { email, origin: window.location.origin });
        setSent(true);
      } else {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.token) localStorage.setItem("lc_admin_token", data.token);
        toast.success("Bienvenido, administrador");
        nav("/admin");
      }
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full rounded-xl border-2 border-[var(--lc-border)] focus:border-[var(--lc-primary)] focus:ring-4 focus:ring-[var(--lc-primary)]/20 outline-none transition-colors p-3.5 bg-[var(--lc-bg)]";

  return (
    <div className="min-h-screen bg-[var(--lc-bg)] lc-dots grid place-items-center px-4">
      <div className="w-full max-w-md bg-white rounded-3xl border border-[var(--lc-border)] shadow-xl p-8 sm:p-10 lc-fade-up">
        <div className="flex items-center gap-3 mb-6">
          <img src="/logo-icon.png" alt="Edibrante" className="w-12 h-12 object-contain select-none" draggable="false" />
          <div>
            <p className="font-display font-extrabold text-xl text-[var(--lc-ink)]">
              Panel Administrador
            </p>
            <p className="text-sm text-[var(--lc-slate)]">Edibrante</p>
          </div>
        </div>

        {mode === "forgot" && sent ? (
          <div className="text-center py-2" data-testid="admin-forgot-sent">
            <p className="text-[var(--lc-ink)] font-semibold">Revisa tu correo</p>
            <p className="text-[var(--lc-slate)] text-sm mt-1 mb-5">
              Si existe una cuenta con <strong>{email}</strong>, te enviamos un enlace para
              restablecer tu contraseña. Vence en 1 hora.
            </p>
            <button
              onClick={() => { setMode("login"); setSent(false); }}
              data-testid="admin-forgot-back"
              className="font-bold text-[var(--lc-primary)] hover:underline"
            >
              Volver a iniciar sesión
            </button>
          </div>
        ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-bold text-[var(--lc-ink)] mb-1 block">Correo</label>
            <input
              type="email"
              className={field}
              data-testid="admin-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@lecturaconfiable.com"
              required
            />
          </div>
          {mode === "login" && (
          <div>
            <label className="text-sm font-bold text-[var(--lc-ink)] mb-1 block">Contraseña</label>
            <input
              type="password"
              className={field}
              data-testid="admin-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          )}
          {mode === "login" && (
            <div className="text-right -mt-1">
              <button type="button" onClick={() => setMode("forgot")} data-testid="admin-forgot-link"
                className="text-sm font-semibold text-[var(--lc-primary)] hover:underline">
                ¿Olvidaste tu contraseña?
              </button>
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-button"
            className="w-full flex items-center justify-center gap-2 rounded-full bg-[var(--lc-primary)] text-white py-3.5 font-display font-extrabold text-lg transition-transform hover:-translate-y-1 disabled:opacity-60 shadow-[0_10px_20px_-4px_rgba(14,165,233,0.45)]"
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Lock className="w-5 h-5" />}
            {mode === "forgot" ? "Enviar enlace" : "Ingresar"}
          </button>
          {mode === "forgot" && (
            <p className="text-center text-sm text-[var(--lc-slate)]">
              <button type="button" onClick={() => setMode("login")} data-testid="admin-forgot-cancel"
                className="font-bold text-[var(--lc-primary)] hover:underline">
                Volver a iniciar sesión
              </button>
            </p>
          )}
        </form>
        )}
      </div>
    </div>
  );
}
